const links = [
  { label: "GitHub", href: "https://github.com/gitChang" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/charlie-g-pandacan" },
  { label: "Email", href: "mailto:charliepandacan@gmail.com" },
];

export default function FindMe() {
  return (
    <div className="find-me">
      <span className="find-me-label">Find me on</span>
      <span className="find-me-links">
        {links.map((l, i) => (
          <span key={l.label}>
            {i > 0 && <span className="find-me-sep">/</span>}
            <a href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
          </span>
        ))}
      </span>
    </div>
  );
}